import App from './App.svelte';

new App({
  target: document.getElementById( 'business-manager-calendar' ),
});